import type { Course } from "../types/learning";

/** A course pair: `base` is the language you learn FROM, `target` the one you learn. */
export type Pair = Pick<Course, "base" | "target">;

/** Every course-scoped URL carries the pair as /from/to, e.g. /app/learn/en/es. */
export function learnPath(c: Pair): string {
  return `/app/learn/${c.base}/${c.target}`;
}

export function lessonPath(c: Pair, lessonId: string): string {
  return `${learnPath(c)}/lesson/${lessonId}`;
}

export function practicePath(c: Pair): string {
  return `${learnPath(c)}/practice`;
}

export function bookPath(c: Pair): string {
  return `${learnPath(c)}/book`;
}

export function wordsPath(c?: Pair): string {
  return c ? `/app/words/${c.base}/${c.target}` : "/app/words";
}

export function translatePath(from: string, to: string): string {
  return `/app/translate/${from}/${to}`;
}
